import { WhatsAppIcon } from "./WhatsAppButton";

interface Props {
  /** Where "Back to WhatsApp" goes (see lib/express-cart/link-source.ts). */
  whatsAppUrl: string;
}

/**
 * Floating button (bottom-right) for shoppers who opened the cart from a
 * WhatsApp chat (`?src=whatsapp`): takes them back to the conversation.
 */
export function ChatReturnButton({ whatsAppUrl }: Props) {
  return (
    <a
      href={whatsAppUrl}
      aria-label="Back to WhatsApp"
      title="Back to WhatsApp"
      className="fixed right-4 bottom-24 z-20 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition hover:scale-105 hover:shadow-xl focus-visible:ring-4 focus-visible:ring-[#25D366]/40 focus-visible:outline-none motion-reduce:transition-none motion-reduce:hover:scale-100 lg:right-6 lg:bottom-6"
    >
      <WhatsAppIcon className="h-7 w-7" />
    </a>
  );
}
